/**
 * initAddLinkAttributes
 * =================
 * This functon will add the noopener noreferrer nofollow attributes
 * to every external link link to prevent security issues
 */
const initAddLinkAttributes = () => {
  const domain = window.location.hostname;
  const anchors = document.querySelectorAll( `a[href^="http"]:not([href*="${domain}])` )

  anchors.forEach(anchor => anchor.setAttribute( 'rel', 'noopener noreferrer nofollow'));
}

export default initAddLinkAttributes;